import React, { FC, Fragment } from 'react';
import { qantasHotels } from 'roo-ui/logos';
import { rem } from 'polished';
import { Container, Flex, Link } from 'roo-ui/components';
import styled from '@emotion/styled';
import { NavigationLinks } from './NavigationLinks';
import { QantasUniversalNav } from '../QantasUniversalNav';
import { QffMenu } from './QffMenu';
import { QCOM_LANDING_PAGE_URL } from '../../../lib/config';

const LOGO_WIDTH = rem('186px');

const Logo = styled.img`
  display: inline-flex;
  width: ${LOGO_WIDTH};
`;

const HeaderInner = styled(Flex)`
  justify-content: space-between;
  align-items: flex-end;

  @media print {
    display: none;
  }
`;

export const HeaderDesktop: FC = () => (
  <Fragment>
    <QantasUniversalNav />
    <Container pr={4}>
      <HeaderInner>
        <Link
          href={QCOM_LANDING_PAGE_URL}
          mr={4}
          mb={2}
          p={1}
          data-testid="qh-logo-link"
        >
          <Logo
            src={qantasHotels}
            alt="Qantas"
            role="img"
            aria-label="Qantas Logo"
          />
        </Link>
        <Flex data-print-style="hidden" mb={-2} data-testid="desktop-qff-menu">
          <QffMenu />
        </Flex>
      </HeaderInner>
    </Container>
    <NavigationLinks />
  </Fragment>
);
